import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import { Button } from '../Button';
import { DiscountBlock } from '../DiscountBlock';
import { SubscriptionCardV9 } from '../SubscriptionCardV9';
import { PaymentInformationBlock } from '../PaymentInformationBlock';
import { CancelAnytimeBlock } from '../CancelAnytimeBlock';
import styles from './SubscriptionPlanSelectorV9.css';

const cx = classnames.bind(styles);

function SubscriptionPlanSelectorV9({ className, plans, onSubmit, defaultPlan, isPending, expiryTimestamp, onExpirePromo, isExpired, defaultDiscountValue, renderRiskConcernSummary }) {
    const classes = cx({
        root: true,
        [className]: Boolean(className)
    });
    const [selectedSubscriptionData, selectSubscription] = useState(plans.find(({ plan }) => plan === defaultPlan) || {});

    useEffect(() => {
        if (defaultPlan) {
            selectSubscription(plans.find(({ plan }) => plan === defaultPlan) || {});
        }
    }, [defaultPlan]);

    return (
        <div className={classes}>
            <DiscountBlock
                expiryTimestamp={expiryTimestamp}
                onExpirePromo={onExpirePromo}
                isExpired={isExpired}
                defaultDiscountText='Your'
                defaultValue={defaultDiscountValue}
                expiresLabel='discount ends in'
            />
            {renderRiskConcernSummary?.()}
            <div className={styles.plans}>
                {plans.map(plan => (
                    <SubscriptionCardV9
                        subscriptionData={plan}
                        selectedSubscriptionData={selectedSubscriptionData}
                        selectSubscription={selectSubscription}
                        isExpired={isExpired}
                        key={plan.plan}
                    />
                ))}
            </div>
            <Button
                label='SUBSCRIBE'
                onClick={() => onSubmit(selectedSubscriptionData)}
                className={cx('button', 'animation')}
                isLoading={isPending}
            />
            <CancelAnytimeBlock />
            <PaymentInformationBlock label='pay securely' />
        </div>
    );
}

SubscriptionPlanSelectorV9.propTypes = {
    className: PropTypes.string,
    plans: PropTypes.array.isRequired,
    onSubmit: PropTypes.func.isRequired,
    defaultPlan: PropTypes.string,
    isPending: PropTypes.bool,
    expiryTimestamp: PropTypes.any,
    onExpirePromo: PropTypes.func,
    isExpired: PropTypes.bool,
    defaultDiscountValue: PropTypes.number,
    renderRiskConcernSummary: () => null
};

SubscriptionPlanSelectorV9.defaultProps = {
    className: '',
    isPending: false
};

export {
    SubscriptionPlanSelectorV9
};
